import styled, { keyframes } from 'styled-components';
const pulse = keyframes(["0%{background-color:var(--trellis-color-fill-tertiary-default)}50%{background-color:var(--trellis-color-fill-surface-default)}100%{background-color:var(--trellis-color-fill-tertiary-default)}"]);
const AnimatedBg = styled.div.withConfig({
  displayName: "AnimatedBg",
  componentId: "sc-1d7wvv-0"
})(["animation:", " 1s infinite;width:100%;height:100%;"], pulse);
export default AnimatedBg;